import { useFormStore } from '@/stores/form'
import { useAuthStore } from '@/stores/auth'
import apiHelperService from '@/services'

const fetchInfo = async () => {
  return await apiHelperService.get(`/api/individual/info`)
}
const initInfo = async () => {
  const authStore = useAuthStore()
  if (authStore.user.applicationId == 2) {
    return
  }
  const formStore = useFormStore()
  const res = await fetchInfo()
  const { arabicFullName, englishFullName, fileNumber, personFileType } = res
  setTimeout(() => {
    formStore.form.setValues({
      sponsorArabicName: arabicFullName,
      sponsorEnglishName: englishFullName,
      sponsorFileNumber: fileNumber,
      sponsorTypeId: personFileType.id
    })
  }, 2000)
}

export default async function () {
  const formStore = useFormStore()

  try {
    formStore.extraMap = {
      localAddressUserActionEnum: null,
      administrativeRegionId: null
    }
    await initInfo()
  } catch (error) {
    console.error('use165Preload', error)
  }
}
